// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixLocation from 'wix-location';

$w.onReady(function () 
{
	// TODO: write your page related code here...

});


export function dropdown_change(event, $w) 
{
    console.log(event.target.value);
	//window.open(event.target.value, '_blank');
    wixLocation.to(event.target.value);
}

function toggleFold(item, sub = 0, under = 0, subs = 0) 
{
	console.log("item: " + item + " " + "sub: " + sub);
	if (sub === 0 && under === 0 && subs === 0)
	{
		console.log("ITEM");
		let $fold = $w('#fold' + item);
		let $arrowDown = $w('#btn' + item + 'v');
		let $arrowRight = $w('#btn' + item);
		// toggle the fold at the index
		if ($fold.collapsed) {
			$fold.expand();
			$arrowDown.show();
			$arrowRight.hide();
		}
		else {
			$fold.collapse();
			$arrowDown.hide();
			$arrowRight.show();
		}
	}
	else if (sub > 0 && under === 0 && subs === 0)
	{
		console.log("SUB");
		let $subFold = $w('#fold' + item + 'sub' + sub);
		let $subArrowDown = $w('#btn' + item + 'sub' + sub + 'v');
		let $subArrowRight = $w('#btn' + item + 'sub' + sub);
		// toggle the fold at the index
		if ($subFold.collapsed) {
			$subFold.expand();
			$subArrowDown.show();
			$subArrowRight.hide();
		}
		else {
			$subFold.collapse();
			$subArrowDown.hide();
			$subArrowRight.show();
		}
	}
	else if (under > 0 && subs === 0)
	{
		console.log("UNDER");
		let $underFold = $w('#fold' + item + 'sub' + sub + 'under' + under);
		let $underArrowDown = $w('#btn' + item + 'sub' + sub + 'under' + under + 'v');
		let $underArrowRight = $w('#btn' + item + 'sub' + sub + 'under' + under);
		// toggle the fold at the index
		if ($underFold.collapsed) {
			$underFold.expand();
			$underArrowDown.show();
			$underArrowRight.hide();
		}
		else {
			$underFold.collapse();
			$underArrowDown.hide();
			$underArrowRight.show();
		}
	}
	else if (subs > 0)
	{
		console.log("SUBS");
		let $subsFold = $w('#fold' + item + 'sub' + sub + 'under' + under + 'subs' + subs);
		let $subsArrowDown = $w('#btn' + item + 'sub' + sub + 'under' + under + 'subs' + subs + 'v');
		let $subsArrowRight = $w('#btn' + item + 'sub' + sub + 'under' + under + 'subs' + subs);
		// toggle the fold at the index
		if ($subsFold.collapsed) {
			$subsFold.expand();
			$subsArrowDown.show();
			$subsArrowRight.hide();
		}
		else {
			$subsFold.collapse();
			$subsArrowDown.hide();
			$subsArrowRight.show();
		}
	}
	
	
	// collapse the other folds
	/*[1,2,3,4]
		.filter(idx => idx !== item)
		.forEach(idx => {
			$w('#fold' + idx).collapse();
			$w('#arrowDown' + idx).hide();
			$w('#arrowRight' + idx).show();
		})*/
}

// 1) Out of Shadows
export function item1_onClick(event) { toggleFold(1, 0); }
		export function sub1Item1_onClick(event) { toggleFold(1, 1)}
		export function sub2Item1_onClick(event) { toggleFold(1, 2)}
// 2) Fall Cabal
export function item2_onClick(event) {	toggleFold(2, 0); }
		export function sub1Item2_onClick(event) { toggleFold(2, 1)}
				export function under1Sub1Item2_onClick(event) { toggleFold(2, 1, 1)}
						export function subs1Under1Sub1Item2_onClick(event) { toggleFold(2, 1, 1, 1)}
						export function subs2Under1Sub1Item2_onClick(event) { toggleFold(2, 1, 1, 2)}
						export function subs3Under1Sub1Item2_onClick(event) { toggleFold(2, 1, 1, 3)}
						export function subs4Under1Sub1Item2_onClick(event) { toggleFold(2, 1, 1, 4)}
						export function subs5Under1Sub1Item2_onClick(event) { toggleFold(2, 1, 1, 5)}
						export function subs6Under1Sub1Item2_onClick(event) { toggleFold(2, 1, 1, 6)}
						export function subs7Under1Sub1Item2_onClick(event) { toggleFold(2, 1, 1, 7)}
						export function subs8Under1Sub1Item2_onClick(event) { toggleFold(2, 1, 1, 8)}
						export function subs9Under1Sub1Item2_onClick(event) { toggleFold(2, 1, 1, 9)}
						export function subs10Under1Sub1Item2_onClick(event) { toggleFold(2, 1, 1, 10)}
						export function subs11Under1Sub1Item2_onClick(event) { toggleFold(2, 1, 1, 11)}
		export function sub2Item2_onClick(event) { toggleFold(2, 2)}
				export function under2Sub2Item2_onClick(event) { toggleFold(2, 2, 2)}
						export function subs1Under2Sub2Item2_onClick(event) { toggleFold(2, 2, 2, 1)}
						export function subs2Under2Sub2Item2_onClick(event) { toggleFold(2, 2, 2, 2)}
						export function subs3Under2Sub2Item2_onClick(event) { toggleFold(2, 2, 2, 3)}
						export function subs4Under2Sub2Item2_onClick(event) { toggleFold(2, 2, 2, 4)}
// 3) Plandemic
export function item3_onClick(event) {	toggleFold(3, 0); }
		export function sub1Item3_onClick(event) { toggleFold(3, 1)}
				export function under1Sub1Item3_onClick(event) { toggleFold(3, 1, 1)}
						export function subs1Under1Sub1Item3_onClick(event) { toggleFold(3, 1, 1, 1)}
						export function subs2Under1Sub1Item3_onClick(event) { toggleFold(3, 1, 1, 2)}
		export function sub2Item3_onClick(event) { toggleFold(3, 2)}
				export function under2Sub2Item3_onClick(event) { toggleFold(3, 2, 2)}
						export function subs1Under2Sub2Item3_onClick(event) { toggleFold(3, 2, 2, 1)}
						export function subs2Under2Sub2Item3_onClick(event) { toggleFold(3, 2, 2, 2)}
						export function subs3Under2Sub2Item3_onClick(event) { toggleFold(3, 2, 2, 3)}
						export function subs4Under2Sub2Item3_onClick(event) { toggleFold(3, 2, 2, 4)}
						export function subs5Under2Sub2Item3_onClick(event) { toggleFold(3, 2, 2, 5)}
						export function subs6Under2Sub2Item3_onClick(event) { toggleFold(3, 2, 2, 6)}
// 4) Mouthy Budha						
export function item4_onClick(event) {	toggleFold(4, 0); }
		export function sub1Item4_onClick(event) { toggleFold(4, 1)}
				export function under1Sub1Item4_onClick(event) { toggleFold(4, 1, 1)}
						export function subs1Under1Sub1Item4_onClick(event) { toggleFold(4, 1, 1, 1)}
						export function subs2Under1Sub1Item4_onClick(event) { toggleFold(4, 1, 1, 2)}
						export function subs3Under1Sub1Item4_onClick(event) { toggleFold(4, 1, 1, 3)}
						export function subs4Under1Sub1Item4_onClick(event) { toggleFold(4, 1, 1, 4)}
		export function sub2Item4_onClick(event) { toggleFold(4, 2)}
				export function under2Sub2Item4_onClick(event) { toggleFold(4, 2, 2)}
						export function subs1Under2Sub2Item4_onClick(event) { toggleFold(4, 2, 2, 1)}
						export function subs2Under2Sub2Item4_onClick(event) { toggleFold(4, 2, 2, 2)}
						export function subs3Under2Sub2Item4_onClick(event) { toggleFold(4, 2, 2, 3)}
						export function subs4Under2Sub2Item4_onClick(event) { toggleFold(4, 2, 2, 4)}
						export function subs5Under2Sub2Item4_onClick(event) { toggleFold(4, 2, 2, 5)}
						export function subs6Under2Sub2Item4_onClick(event) { toggleFold(4, 2, 2, 6)}
						export function subs7Under2Sub2Item4_onClick(event) { toggleFold(4, 2, 2, 7)}
						export function subs8Under2Sub2Item4_onClick(event) { toggleFold(4, 2, 2, 8)}
		export function sub3Item4_onClick(event) { toggleFold(4, 3)}
				export function under3Sub3Item4_onClick(event) { toggleFold(4, 3, 3)}
						export function subs1Under3Sub3Item4_onClick(event) { toggleFold(4, 3, 3, 1)}
						export function subs2Under3Sub3Item4_onClick(event) { toggleFold(4, 3, 3, 2)}
						export function subs3Under3Sub3Item4_onClick(event) { toggleFold(4, 3, 3, 3)}
		export function sub4Item4_onClick(event) { toggleFold(4, 4)}
				export function under4Sub4Item4_onClick(event) { toggleFold(4, 4, 4)}
						export function subs1Under4Sub4Item4_onClick(event) { toggleFold(4, 4, 4, 1)}
						export function subs2Under4Sub4Item4_onClick(event) { toggleFold(4, 4, 4, 2)}
						export function subs3Under4Sub4Item4_onClick(event) { toggleFold(4, 4, 4, 3)}
// 5) Corbett Report
export function item5_onClick(event) {	toggleFold(5, 0); }
		export function sub1Item5_onClick(event) { toggleFold(5, 1)}
				export function under1Sub1Item5_onClick(event) { toggleFold(5, 1, 1)}
						export function subs1Under1Sub1Item5_onClick(event) { toggleFold(5, 1, 1, 1)}
						export function subs2Under1Sub1Item5_onClick(event) { toggleFold(5, 1, 1, 2)}
						export function subs3Under1Sub1Item5_onClick(event) { toggleFold(5, 1, 1, 3)}
						export function subs4Under1Sub1Item5_onClick(event) { toggleFold(5, 1, 1, 4)}
		export function sub2Item5_onClick(event) { toggleFold(5, 2)}
				export function under2Sub2Item5_onClick(event) { toggleFold(5, 2, 2)}
						export function subs1Under2Sub2Item5_onClick(event) { toggleFold(5, 2, 2, 1)}
						export function subs2Under2Sub2Item5_onClick(event) { toggleFold(5, 2, 2, 1)}
						export function subs3Under2Sub2Item5_onClick(event) { toggleFold(5, 2, 2, 1)}
// 6) Spiro Soukas
export function item6_onClick(event) {	toggleFold(6, 0); }
		export function sub1Item6_onClick(event) { toggleFold(6, 1)}
				export function under1Sub1Item6_onClick(event) { toggleFold(6, 1, 1)}
						export function subs1Under1Sub1Item6_onClick(event) { toggleFold(6, 1, 1, 1)}
// 7) Joe M
export function item7_onClick(event) {	toggleFold(7, 0); }
		export function sub1Item7_onClick(event) { toggleFold(7, 1)}
				export function under1Sub1Item7_onClick(event) { toggleFold(7, 1, 1)}
						export function subs1Under1Sub1Item7_onClick(event) { toggleFold(7, 1, 1, 1)}
						export function subs2Under1Sub1Item7_onClick(event) { toggleFold(7, 1, 1, 2)}
						export function subs3Under1Sub1Item7_onClick(event) { toggleFold(7, 1, 1, 3)}
						export function subs4Under1Sub1Item7_onClick(event) { toggleFold(7, 1, 1, 4)}
						export function subs5Under1Sub1Item7_onClick(event) { toggleFold(7, 1, 1, 5)}
						export function subs6Under1Sub1Item7_onClick(event) { toggleFold(7, 1, 1, 6)}
						export function subs7Under1Sub1Item7_onClick(event) { toggleFold(7, 1, 1, 7)}
						export function subs8Under1Sub1Item7_onClick(event) { toggleFold(7, 1, 1, 8)}
						export function subs9Under1Sub1Item7_onClick(event) { toggleFold(7, 1, 1, 9)}
// 8) Valuetainment
export function item8_onClick(event) {	toggleFold(8, 0); }
		export function sub1Item8_onClick(event) { toggleFold(8, 1)}
				export function under1Sub1Item8_onClick(event) { toggleFold(8, 1, 1)}
						export function subs1Under1Sub1Item8_onClick(event) { toggleFold(8, 1, 1, 1)}
						export function subs2Under1Sub1Item8_onClick(event) { toggleFold(8, 1, 1, 2)}
						export function subs3Under1Sub1Item8_onClick(event) { toggleFold(8, 1, 1, 3)}
						export function subs4Under1Sub1Item8_onClick(event) { toggleFold(8, 1, 1, 4)}










// 11) French Resistance
export function item11_onClick(event) {	toggleFold(11, 0); }
		export function sub1Item11_onClick(event) { toggleFold(11, 1)}
				export function under1Sub1Item11_onClick(event) { toggleFold(11, 1, 1)}
						export function subs1Under1Sub1Item11_onClick(event) { toggleFold(11, 1, 1, 1)}
						export function subs2Under1Sub1Item11_onClick(event) { toggleFold(11, 1, 1, 2)}
						export function subs3Under1Sub1Item11_onClick(event) { toggleFold(11, 1, 1, 3)}
// 12) Zeitgeist
export function item12_onClick(event) {	toggleFold(12, 0); }
		export function sub1Item12_onClick(event) { toggleFold(12, 1)}
				export function under1Sub1Item12_onClick(event) { toggleFold(12, 1, 1)}
						export function subs1Under1Sub1Item12_onClick(event) { toggleFold(12, 1, 1, 1)}
						export function subs2Under1Sub1Item12_onClick(event) { toggleFold(12, 1, 1, 2)}
						export function subs3Under1Sub1Item12_onClick(event) { toggleFold(12, 1, 1, 3)}
// 13) VAXXED
export function item13_onClick(event) {	toggleFold(13, 0); }
		export function sub1Item13_onClick(event) { toggleFold(13, 1)}
				export function under1Sub1Item13_onClick(event) { toggleFold(13, 1, 1)}
						export function subs1Under1Sub1Item13_onClick(event) { toggleFold(13, 1, 1, 1)}
						export function subs2Under1Sub1Item13_onClick(event) { toggleFold(13, 1, 1, 2)}
						export function subs3Under1Sub1Item13_onClick(event) { toggleFold(13, 1, 1, 3)}
				
						



/**
*	Adds an event handler that runs when an input element's value
 is changed.
*	 @param {$w.Event} event
*/
export function dropdown4_change(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}